.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
	max-height: var(--dialog-max-h);
	overflow-y: auto;
}

.heading {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.hint {
	margin: 0;
	font-size: 0.8rem;
	color: var(--ink-muted);
}

.field {
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
}

.label {
	font-size: 0.75rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.tagPills {
	display: flex;
	flex-wrap: wrap;
	gap: var(--space-2);
}

.tagPill {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 6px var(--space-3);
	border-radius: 999px;
	background: var(--surface-input);
	color: var(--ink);
	border: 1px solid color-mix(in srgb, var(--ink) 10%, transparent);
	font: inherit;
	font-size: 0.85rem;
	cursor: pointer;
	transition:
		background 0.1s ease,
		border-color 0.1s ease;
}

.tagPill:hover:not(.tagPillActive) {
	border-color: color-mix(in srgb, var(--ink) 22%, transparent);
}

.tagPillActive {
	background: color-mix(in srgb, var(--accent-sage) 22%, transparent);
	border-color: var(--accent-sage);
	font-weight: 600;
}

.actions {
	display: flex;
	justify-content: flex-end;
	gap: var(--space-2);
}

.later {
	padding: var(--space-2) var(--space-4);
	background: transparent;
	border: 1px solid color-mix(in srgb, var(--ink) 18%, transparent);
	border-radius: var(--radius-md);
	color: var(--ink);
	font: inherit;
	cursor: pointer;
}

.done {
	padding: var(--space-2) var(--space-4);
	background: var(--accent-sage);
	border: none;
	border-radius: var(--radius-md);
	color: #fff;
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}

.done:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.tagPill:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
